import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Constants from '../Constants';
import '../App.css';

function PaymentErrorView() {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	useEffect(() => {
		const session_id = searchParams.get('session_id');
		if(session_id) {
			axios.get(Constants.SERVER_URL + '/api/payment/cancel_session/' + session_id)
				.catch(err => console.error('PaymentErrorView - cancel_session error:', err.message));
		}
	}, [searchParams]);

	function handleRetry() {
		navigate('/plans');
	}

	return (
		<Container fluid className="auth-container">
			<Row className="auth-row">
				<Col lg={6} md={8} sm={10}>
					<Card className="p-4 shadow-lg text-center bg-dark text-light border-danger">
						<Card.Body>
							<h3 className="mb-4" style={{ color: '#ff6666' }}>
								Payment Failed
							</h3>
							<p className="text-light mb-4">
								Something went wrong while processing your payment. Your card has not been charged.
							</p>
							<Button variant="danger" className="me-3" onClick={handleRetry}>
								Try Again
							</Button>
							<Button variant="secondary" onClick={() => navigate('/')}>
								Return Home
							</Button>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Container>
	);
}

export default PaymentErrorView;
